import { render } from "./GMvirtualCommerce.vue?vue&type=template&id=ec1cccd0&scoped=true"
import script from "./GMvirtualCommerce.vue?vue&type=script&lang=js"
export * from "./GMvirtualCommerce.vue?vue&type=script&lang=js"

import "./GMvirtualCommerce.vue?vue&type=style&index=0&id=ec1cccd0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ec1cccd0"

export default script